import sitemapProcessing from './sitemapProcessing'
import cascadeDeleting from './cascadeDeleting'
import accounts from './accounts'
import redirects from './redirects'
import sites from './sites'
import register from './register'
import queuePagination from './queuesPagination'

export default [register, sitemapProcessing, cascadeDeleting, queuePagination, accounts, sites, redirects]



// WEBPACK FOOTER //
// ./src/redux/middlewares/index.js